import { useId } from "react";

import { cn } from "@/lib/utils";

export function AllCategoriesIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn(
        "h-4.5 w-[19px] text-slate-gray transition-colors",
        className
      )}
      fill="none"
      viewBox="0 0 19 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M6.955 11.664c-.96-.75-1.686-1.577-2.09-2.291-.204-.359-.314-.668-.347-.91-.032-.24.016-.375.076-.452.06-.076.179-.155.42-.182.242-.028.569.004.966.114.792.22 1.77.722 2.73 1.472s1.687 1.576 2.092 2.29c.203.36.313.668.346.91.032.24-.016.376-.076.452-.06.077-.179.156-.42.183-.242.027-.569-.005-.966-.115-.792-.219-1.77-.722-2.73-1.471zM3.852 7.433c-.262.336-.32.752-.265 1.155.013.095.032.192.057.29L2.6 16.485a.509.509 0 00.687.544l7.324-2.833c.05-.003.098-.007.146-.012.403-.045.793-.202 1.056-.538.262-.337.32-.753.265-1.155-.054-.4-.22-.827-.46-1.249-.479-.846-1.297-1.762-2.33-2.568-1.034-.807-2.121-1.377-3.058-1.637-.468-.13-.921-.188-1.323-.142-.403.045-.793.202-1.056.538z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M6.083 8.508c.854-.727 1.191-1.527 1.118-2.649-.051-.778-.295-1.408-.742-1.905m3.91 7.365c.47-1.02 1.148-1.56 2.245-1.788.624-.13 1.188-.107 1.7.07m-6.192.497L13.277 3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="0.8"
      />
      <circle
        cx="2.419"
        cy="2.919"
        fill="currentColor"
        r="0.75"
        transform="rotate(-15 2.419 2.919)"
      />
      <circle
        cx="15.419"
        cy="6.919"
        fill="currentColor"
        r="0.75"
        transform="rotate(-15 15.419 6.919)"
      />
      <circle
        cx="16.419"
        cy="1.794"
        fill="currentColor"
        r="0.75"
        transform="rotate(-15 16.419 1.794)"
      />
      <path
        d="M9.384.388A.15.15 0 019.66.314l.471.725a.15.15 0 00.165.063L11.13.88a.15.15 0 01.156.239l-.545.672a.15.15 0 00-.009.176l.471.726a.15.15 0 01-.18.221l-.807-.31a.15.15 0 00-.17.046l-.545.672a.15.15 0 01-.266-.102l.045-.864a.15.15 0 00-.096-.148l-.807-.31a.15.15 0 01.015-.285l.835-.223a.15.15 0 00.111-.137l.045-.864zM14.7 11.112a.15.15 0 01.277-.074l.684 1.055a.15.15 0 00.165.063l1.214-.325a.15.15 0 01.156.239l-.792.977a.15.15 0 00-.009.176l.685 1.054a.15.15 0 01-.18.222l-1.173-.45a.15.15 0 00-.17.045l-.792.977a.15.15 0 01-.266-.102l.066-1.255a.15.15 0 00-.096-.148l-1.174-.45a.15.15 0 01.015-.286l1.214-.325a.15.15 0 00.111-.137l.066-1.256z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EscapeRoomsCategoryIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn(
        "h-4.5 w-[19px] text-slate-gray transition-colors",
        className
      )}
      fill="none"
      viewBox="0 0 19 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M15.443 7.418c-.784 1.301-2.93 1.489-5.073.548l-.776 1.29-1.615 2.681 2.008 1.207a.375.375 0 01.129.515l-.381.634a.375.375 0 01-.515.128l-.54-.324a.375.375 0 00-.514.128l-.514.855a.375.375 0 00.128.515l.54.324a.375.375 0 01.128.515l-.33.55a.375.375 0 01-.514.128l-2.013-1.21-.34.564a1.051 1.051 0 11-1.8-1.085l2.324-3.86 2.018-3.35.776-1.288C6.73 5.429 5.889 3.44 6.673 2.137c.898-1.492 3.59-1.52 6.011-.06 2.422 1.458 3.657 3.85 2.759 5.341zM12.22 2.884c.586.353.887.989.81 1.586.295.002.599.083.877.25.771.465 1.048 1.42.619 2.133-.43.713-1.403.914-2.174.45a1.722 1.722 0 01-.631-.659c-.492.348-1.195.38-1.781.027-.586-.353-.887-.989-.81-1.587a1.721 1.721 0 01-.876-.25c-.772-.464-1.05-1.419-.62-2.132.43-.713 1.403-.914 2.175-.45.277.168.49.398.63.658.493-.348 1.195-.379 1.781-.026z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M10.37 7.966l.151-.343a.375.375 0 00-.472.15l.321.193zm5.073-.548l-.322-.193.322.193zM9.594 9.256l.321.193-.321-.193zm-1.615 2.681l-.321-.193a.375.375 0 00.128.515l.193-.322zm2.008 1.207l.194-.321-.194.321zm.129.515l.321.193-.321-.193zm-.381.634l-.322-.193.322.193zm-.515.128l.193-.321-.193.321zm-.54-.324l-.193.322.193-.322zm-.514.128l-.322-.193.322.193zm-.514.855l.322.194-.322-.194zm.128.515l-.193.321.193-.321zm.54.324l.193-.321-.193.321zm.128.515l-.321-.193.321.193zm-.33.55l.322.192-.322-.193zm-.514.128l.193-.322-.193.322zm-2.013-1.21l.193-.321a.375.375 0 00-.514.128l.321.193zm-.34.564l-.32-.193.32.193zm-1.442.358l-.194.321.194-.32zm-.358-1.443l-.322-.193.322.194zm2.324-3.86l-.32-.193.32.193zm2.018-3.35l-.321-.193.321.193zm.776-1.288l.321.193a.375.375 0 00-.089-.487l-.232.294zM6.673 2.137l-.322-.194.322.194zm6.011-.06l.194-.322-.194.321zm.347 2.393l-.372-.048a.375.375 0 00.37.423l.002-.375zm-.81-1.586l.194-.321-.194.32zm1.687 1.836l-.194.322.194-.322zm.619 2.133l.321.193-.321-.193zm-2.174.45l-.194.32.194-.32zm-.631-.659l.33-.177a.375.375 0 00-.547-.129l.217.306zm-1.781.027l-.194.32.194-.32zm-.81-1.587l.372.049a.375.375 0 00-.37-.424l-.002.375zm-.876-.25l.193-.32-.193.32zm-.62-2.132l.321.194-.32-.194zm2.175-.45l.193-.32-.193.32zm.63.658l-.33.178a.375.375 0 00.547.128l-.216-.306zm-.22 5.4c1.118.49 2.255.696 3.234.596.978-.1 1.838-.511 2.31-1.294l-.643-.387c-.311.518-.916.85-1.743.935-.825.084-1.833-.087-2.857-.537l-.301.687zm-.305 1.139l.777-1.29-.643-.386-.776 1.29.642.386zM8.3 12.131l1.615-2.682-.642-.387-1.615 2.682.642.387zm1.88.692l-2.008-1.207-.386.643 2.008 1.207.387-.643zm.257 1.029a.75.75 0 00-.256-1.03l-.387.644.643.386zm-.38.634l.38-.634-.643-.386-.38.634.642.386zm-1.03.257a.75.75 0 001.03-.257l-.644-.386-.386.643zm-.54-.325l.54.325.386-.643-.54-.324-.386.643zm0 0l.387-.642a.75.75 0 00-1.03.256l.643.386zm-.513.856l.513-.855-.643-.387-.513.855.643.386zm0 0l-.643-.387a.75.75 0 00.256 1.03l.387-.643zm.54.324l-.54-.325-.387.643.54.325.386-.643zm.256 1.029a.75.75 0 00-.257-1.03l-.386.644.643.386zm-.33.55l.33-.55-.643-.386-.33.55.643.386zm-1.03.256a.75.75 0 001.03-.256l-.643-.387-.387.643zm-2.012-1.21l2.012 1.21.387-.643-2.013-1.209-.386.643zm.175.437l.34-.564-.643-.387-.34.564.643.387zm-1.958.485a1.426 1.426 0 001.958-.485l-.643-.387a.676.676 0 01-.928.23l-.387.642zm-.486-1.957a1.426 1.426 0 00.486 1.957l.387-.642a.676.676 0 01-.23-.928l-.643-.387zm2.325-3.86l-2.325 3.86.643.387 2.325-3.86-.643-.387zm2.018-3.35l-2.018 3.35.643.387 2.017-3.35-.642-.387zm.775-1.288l-.775 1.288.642.386.776-1.288-.643-.386zM6.351 1.943c-.472.785-.432 1.74-.061 2.651.371.914 1.087 1.824 2.046 2.583l.465-.588c-.879-.696-1.503-1.507-1.817-2.277-.313-.772-.302-1.463.01-1.982l-.643-.387zm6.527-.188C11.618.995 10.272.613 9.104.625c-1.161.012-2.211.42-2.753 1.318l.643.387c.357-.593 1.102-.945 2.117-.955 1.008-.01 2.219.323 3.38 1.023l.387-.643zm2.886 5.857c.541-.899.41-2.018-.122-3.05-.536-1.037-1.503-2.048-2.764-2.807l-.387.643c1.161.699 2.022 1.613 2.485 2.509.465.902.502 1.725.145 2.318l.643.387zm-2.361-3.094c.097-.753-.282-1.53-.988-1.955l-.387.642c.465.28.688.775.631 1.217l.744.096zM14.1 4.4a2.097 2.097 0 00-1.068-.304l-.005.75c.229.002.466.064.686.197L14.1 4.4zm.747 2.647c.55-.914.178-2.09-.747-2.647l-.387.643c.618.372.8 1.105.492 1.617l.642.387zm-2.689.577c.925.557 2.139.337 2.69-.577l-.643-.387c-.309.512-1.041.694-1.66.322l-.387.642zm-.768-.801c.172.319.432.6.768.801l.387-.642a1.346 1.346 0 01-.494-.514l-.66.355zm-1.644.17c.707.425 1.57.397 2.191-.041l-.433-.613c-.364.258-.905.292-1.37.011l-.388.643zM8.76 5.036c-.097.754.282 1.53.988 1.956l.387-.643c-.465-.28-.688-.774-.63-1.216l-.745-.097zm-.698.12c.336.202.706.301 1.068.303l.005-.75a1.346 1.346 0 01-.686-.196l-.387.643zm-.747-2.647c-.55.913-.177 2.09.747 2.647l.387-.643c-.618-.372-.8-1.105-.492-1.617l-.642-.387zm2.69-.578c-.926-.557-2.14-.336-2.69.578l.642.387c.309-.513 1.042-.695 1.66-.322l.387-.643zm.767.802a2.096 2.096 0 00-.768-.802l-.387.643c.22.132.386.313.494.514l.66-.355zm1.644-.17c-.707-.426-1.57-.397-2.19.041l.432.612c.364-.257.905-.291 1.37-.01l.388-.643z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EscapeRoomIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M9.962 4.945c-.522.868-1.953.993-3.382.366l-.517.86-1.077 1.787 1.232.74a.375.375 0 01.128.515l-.125.208a.375.375 0 01-.515.129l-.145-.088a.375.375 0 00-.515.129l-.213.355a.375.375 0 00.128.515l.145.087a.375.375 0 01.129.515l-.092.152a.375.375 0 01-.514.128l-1.235-.742-.226.376a.7.7 0 11-1.2-.723l1.55-2.573 1.344-2.234.517-.858c-1.225-.97-1.787-2.296-1.264-3.165.6-.994 2.394-1.012 4.008-.04 1.615.972 2.438 2.567 1.839 3.561zM7.814 1.922c.391.236.592.66.54 1.058.197.001.4.055.584.167.515.31.7.946.414 1.421-.287.476-.936.61-1.45.3a1.148 1.148 0 01-.42-.439c-.329.232-.797.253-1.188.018-.39-.235-.591-.66-.54-1.058a1.148 1.148 0 01-.584-.166c-.514-.31-.7-.946-.413-1.422.286-.475.935-.61 1.45-.3.185.112.327.266.42.439.328-.232.797-.253 1.187-.018z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M6.58 5.31l.151-.343a.375.375 0 00-.472.15l.321.194zm3.382-.365l.321.194-.321-.194zm-3.9 1.225l-.32-.193.32.193zM4.987 7.958l-.321-.193a.375.375 0 00.128.515l.193-.322zm1.232.74l-.193.322.193-.322zm.128.515l.322.193-.322-.193zm-.125.208L5.9 9.228l.321.193zm-.515.129l.194-.322-.194.322zm-.145-.088l-.193.322.193-.322zm-.515.129l.322.193-.322-.193zm-.213.355l-.322-.193.322.193zm.128.515l.193-.322-.193.322zm.145.087l.194-.321-.194.321zm.129.515l-.322-.193.322.193zm-.092.152l-.321-.193.321.193zm-.514.128l-.193.322.193-.322zm-1.235-.742l.193-.321a.375.375 0 00-.514.128l.321.194zm-.226.376l.321.194-.321-.194zm-.962.239l.194-.321-.194.321zm-.239-.962l-.321-.193.321.193zm1.55-2.573l-.321-.194.321.194zm1.345-2.234l.321.194-.32-.194zm.517-.858l.322.193a.375.375 0 00-.089-.488l-.233.295zM4.115 1.424l.322.194-.322-.194zm4.008-.04l-.193.321.193-.32zm.231 1.596l-.372-.048a.375.375 0 00.37.423l.002-.375zm-.54-1.058l-.193.322.193-.322zm1.124 1.225l.194-.322-.194.322zm.414 1.421l.32.194-.32-.194zm-1.45.3l.193-.321-.193.321zm-.42-.439l.33-.177a.375.375 0 00-.547-.129l.216.306zm-1.188.018l-.193.321.193-.321zm-.54-1.058l.372.049a.375.375 0 00-.37-.424l-.002.375zm-.584-.166l.193-.322-.193.322zM4.757 1.8l.321.194-.321-.194zm1.45-.3l-.194.322.194-.322zm.42.439l-.33.178a.375.375 0 00.547.128l-.217-.306zM6.43 5.654c.76.334 1.54.477 2.219.407.677-.068 1.293-.356 1.634-.922l-.642-.387c-.182.301-.542.51-1.068.563-.525.054-1.175-.055-1.842-.348l-.301.687zm-.046.71l.518-.86-.643-.387-.517.86.642.387zM5.307 8.152l1.077-1.788-.642-.387-1.077 1.788.642.387zm1.104.225l-1.232-.74-.386.643 1.232.74.386-.643zm.257 1.029a.75.75 0 00-.257-1.03l-.386.644.643.386zm-.126.208l.126-.208-.643-.386-.125.208.642.386zm-1.029.257a.75.75 0 001.03-.257L5.9 9.228l-.387.643zm-.145-.087l.145.087.387-.643-.146-.087-.386.643zm0 0l.386-.643a.75.75 0 00-1.03.256l.644.387zm-.214.355l.214-.355-.643-.387-.214.356.643.386zm0 0l-.643-.386a.75.75 0 00.257 1.03l.386-.644zm.146.088l-.146-.088-.386.643.145.088.387-.643zm.256 1.029a.75.75 0 00-.256-1.03l-.387.644.643.386zm-.091.152l.091-.152-.643-.386-.091.152.643.386zm-1.03.257a.75.75 0 001.03-.257l-.643-.386-.386.643zm-1.234-.742l1.235.742.386-.643-1.235-.742-.386.643zm.288.248l.226-.376-.642-.387-.226.376.642.387zm-1.476.366c.509.307 1.17.143 1.476-.366l-.642-.387a.326.326 0 01-.447.11l-.387.643zm-.367-1.476a1.076 1.076 0 00.367 1.476l.387-.642a.326.326 0 01-.111-.447l-.643-.387zm1.55-2.574l-1.55 2.574.643.387 1.55-2.574-.643-.387zM4.54 5.254L3.196 7.487l.642.387 1.345-2.233-.642-.387zm.517-.859l-.517.859.642.387.518-.859-.643-.387zM3.794 1.231c-.341.567-.306 1.248-.05 1.879.257.633.75 1.256 1.403 1.773l.465-.589c-.573-.453-.974-.977-1.173-1.467-.2-.49-.184-.908-.002-1.21l-.643-.386zm4.523-.168C7.46.547 6.54.283 5.735.292 4.936.3 4.185.58 3.794 1.23l.643.387c.207-.344.653-.57 1.305-.576.645-.007 1.43.207 2.188.663l.387-.642zm1.966 4.076c.392-.65.29-1.445-.077-2.155-.37-.715-1.032-1.405-1.89-1.921l-.386.642c.757.457 1.313 1.05 1.61 1.623.299.58.308 1.08.1 1.424l.643.387zm-1.557-2.11c.072-.555-.207-1.12-.718-1.428l-.387.643c.27.162.393.445.361.688l.744.096zm.406-.204a1.523 1.523 0 00-.775-.22l-.005.75c.13 0 .266.036.393.113l.387-.643zm.54 1.937c.408-.676.127-1.535-.54-1.937l-.387.643c.361.218.45.632.285.907l.643.387zm-1.964.427c.668.402 1.558.249 1.965-.427l-.643-.387c-.165.274-.573.39-.935.172l-.387.642zm-.557-.582c.125.232.314.436.557.582l.387-.642a.773.773 0 01-.283-.295l-.661.355zm-1.05.161c.51.308 1.14.29 1.597-.032l-.433-.613a.716.716 0 01-.777.003l-.387.642zm-.719-1.427c-.071.554.207 1.12.719 1.427l.387-.642a.716.716 0 01-.362-.688l-.744-.097zm-.405.203c.243.146.511.219.775.22l.005-.75a.773.773 0 01-.394-.113l-.386.643zm-.541-1.936c-.407.676-.127 1.534.54 1.936l.387-.643c-.36-.217-.45-.632-.285-.906l-.642-.387zM6.4 1.18c-.667-.402-1.557-.248-1.964.428l.642.387c.165-.275.574-.39.935-.172L6.4 1.18zm.558.582A1.523 1.523 0 006.4 1.18l-.387.643a.77.77 0 01.284.295l.66-.356zm1.05-.16c-.511-.309-1.141-.29-1.597.032l.433.612a.716.716 0 01.777-.002l.387-.643z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HauntedHayrideIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 12 10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 5.394v-.62h11.43v.62H0zm.043 2.519C.002 7.828 0 7.79 0 6.92V5.788h11.43V6.92c0 .871-.001.908-.043.993-.066.136-.576.173-.862.173-.23 0-.23 0-.255-.15a1.557 1.557 0 00-1.83-1.27 1.565 1.565 0 00-1.234 1.27l-.024.15H4.249l-.025-.15a1.564 1.564 0 00-1.532-1.3c-.753 0-1.41.557-1.532 1.3-.025.15-.025.15-.255.15-.286 0-.796-.037-.862-.173z"
        fill="currentColor"
      />
      <path
        d="M1.866 7.777a.91.91 0 01.596-.481.764.764 0 01.398-.017c.384.073.681.38.749.776a.937.937 0 01-.678 1.035c-.769.199-1.42-.603-1.065-1.313zm5.955.278a.943.943 0 01.695-.765c.618-.167 1.247.404 1.14 1.035a.943.943 0 01-.783.782c-.591.101-1.153-.46-1.052-1.052z"
        fill="currentColor"
      />
      <path
        clipRule="evenodd"
        d="M7.469 4.34a3.79 3.79 0 00-.264-1.626 2.569 2.569 0 013.816 1.626H7.47zm-.455 0a3.344 3.344 0 10-6.677 0h6.677z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <rect
        fill="currentColor"
        height="0.497"
        rx="0.15"
        width="0.95"
        x="11.049"
        y="6.598"
      />
    </svg>
  );
}

export function HauntedHouseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      fill="none"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.326 2.95s.16-.165.294-.206c.331-.101.749.474.749.474s.195-.683.541-.701c.14-.007.347.093.347.093M9.128.31s.206-.1.346-.092c.346.018.541.702.541.702s.418-.576.749-.474c.134.04.294.205.294.205"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.75"
      />
      <path
        clipRule="evenodd"
        d="M4.29.476c-.032.26-.086.622-.176 1.082-.204 1.046-.204 1.046-.56 1.62-.389.63-.412.698-.276.815a.358.358 0 00.01.009c.075.059.195.059 2.731.059 2.663 0 2.663 0 2.742-.068.136-.118.113-.186-.278-.813-.356-.573-.356-.573-.559-1.606A15.67 15.67 0 017.748.478.538.538 0 007.224 0h-2.41a.538.538 0 00-.524.476zm-2.095 4.02h-.392c-.231 0-.47.132-.538.353-.028.094-.062.212-.102.361C.94 6.027.94 6.027.64 6.365c-.302.34-.336.407-.282.548.049.128.101.132 1.661.132H3.5v-2.55H2.194zM8.54 5.74V4.495h1.612c.277 0 .581.202.656.469l.068.246c.222.817.222.817.522 1.155.302.34.337.407.283.548-.05.128-.101.132-1.661.132H8.54V5.741zM3.962 8.697V12H5.12l.008-.92.002-.153c.007-.82.012-1.357.077-1.489a.912.912 0 011.082-.47c.198.058.427.256.537.464.073.139.078.655.085 1.474l.002.174.009.92h1.156V4.495H3.962v4.202zM.98 11.672c-.02-.053-.03-.536-.03-1.383v-2.78h2.549V12h-1.05c-.6 0-1.094-.013-1.153-.029a.577.577 0 01-.316-.299zm7.561-1.179V12h1.082c1.077 0 1.083 0 1.21-.067a.494.494 0 00.192-.181c.065-.114.065-.122.066-1.44V7.51H8.54v2.984zM6.017 6.005a.87.87 0 00-.87.869v.985h1.739v-.985a.87.87 0 00-.87-.87zm3.07 2.709a.739.739 0 111.479 0v.826H9.088v-.826zm-6.88-.739a.739.739 0 00-.74.739v.826h1.478v-.826a.739.739 0 00-.739-.739z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function HauntedMazeIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      fill="none"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          clipRule="evenodd"
          d="M5.469.627a5.41 5.41 0 00-1.09.217 5.384 5.384 0 00-1.21.555c0 .004.2.209.446.454l.447.446.134-.065a4.18 4.18 0 01.865-.298c.121-.03.42-.072.645-.088.19-.014.287-.014.485 0a3.984 3.984 0 011.585.426 4.1 4.1 0 01.252.132c.025.019.019.032-.124.27l-.162.27c-.01.016-.054-.001-.222-.086a3.62 3.62 0 00-1.06-.344 4.913 4.913 0 00-1.026 0c-.485.082-.9.235-1.31.482-.083.05-.156.09-.163.09-.006 0-.306-.294-.666-.654-.36-.36-.658-.654-.664-.654-.034 0-.43.363-.606.555C1.237 3.2.791 4.16.627 5.345a7.904 7.904 0 000 1.309c.096.695.267 1.246.57 1.836a5.464 5.464 0 002.78 2.522c.238.095.639.22.702.22.02 0 .023-.064.023-.682 0-.682 0-.682-.032-.695-.5-.195-.696-.293-1.017-.508a4.124 4.124 0 01-1.317-1.441 3.967 3.967 0 01-.494-1.948c0-.675.152-1.313.452-1.885l.078-.151c.009-.018.023-.035.032-.038a.475.475 0 01.133.065l.238.139c.196.11.19.071.059.337a3.442 3.442 0 00-.254 2.362c.064.26.193.606.227.606a29.945 29.945 0 001.061-.607c.013-.012.01-.031-.01-.088a2.883 2.883 0 01-.112-.452 2.734 2.734 0 01.013-.67 2.23 2.23 0 011.418-1.71 2.268 2.268 0 011.54 0c.64.242 1.127.75 1.342 1.402.08.24.095.35.096.676 0 .308-.005.35-.07.6-.127.49-.48.969-.932 1.267a2.128 2.128 0 01-1.054.345l-.152.003V7.54l.098-.01c.436-.048.731-.184 1.014-.467a1.566 1.566 0 00-.001-2.235 1.576 1.576 0 00-2.526.42c-.151.31-.2.625-.145.95.039.234.121.439.285.706a.547.547 0 01.058.112c0 .015-.092.07-.547.33-.044.024-.183.105-.31.178l-.49.28c-.14.079-.256.149-.256.155-.001.027.207.275.365.433a3.54 3.54 0 001.773.961 3.74 3.74 0 001.407 0 3.507 3.507 0 002.257-1.595c.194-.313.356-.722.434-1.097a3.632 3.632 0 00-.005-1.428 3.459 3.459 0 00-.448-1.11 2.106 2.106 0 01-.086-.144c0-.004.307-.314.682-.69.683-.682.683-.682.631-.746A5.517 5.517 0 008.022.995 5.45 5.45 0 005.469.627zm4.623 2.986c-.469.47-.469.47-.42.566a4.145 4.145 0 01.391 1.493A4.113 4.113 0 016.791 9.98a4.38 4.38 0 01-1.382.048c-.074-.009-.074-.009-.074.661 0 .369.005.67.01.67l.208.022a5.51 5.51 0 001.526-.092 6.004 6.004 0 001.041-.324 5.516 5.516 0 002.576-2.313c.043-.078.23-.452.259-.52a5.81 5.81 0 00.397-1.485 7.792 7.792 0 000-1.287c-.076-.549-.21-1.062-.378-1.438a.482.482 0 01-.026-.067c0-.036-.36-.71-.379-.71-.004 0-.22.21-.477.468z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M0 0h12v12H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function HauntedTrailIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M8.1 2.4H4.45a.25.25 0 01-.25-.25v-.7a.25.25 0 01.25-.25H8.1a2.7 2.7 0 110 5.4H3.9a1.5 1.5 0 000 3h3v1.2h-3a2.7 2.7 0 010-5.4h4.2a1.5 1.5 0 000-3z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M7.675 10.117a.1.1 0 010 .166l-1.52 1.013A.1.1 0 016 11.213V9.187a.1.1 0 01.155-.083l1.52 1.013z"
        fill="currentColor"
      />
      <circle cx="2.4" cy="1.8" fill="currentColor" r="1.2" />
      <circle cx="9.6" cy="10.2" fill="currentColor" r="1.2" />
    </svg>
  );
}

export function HauntedZoneIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M4.538.601a.2.2 0 00-.2.2v1.096c0 .11.089.2.2.2h.846a.2.2 0 00.2-.2V.805a.2.2 0 00-.2-.2L4.539.602zm-3.14 1.932c-.11 0-.198.09-.198.199v3.456c0 .11.09.2.2.2h6.874a.411.411 0 00.247-.082l.947-.709c.58-.434 1.1-.837 1.152-.894a.335.335 0 00-.021-.49c-.065-.059-.586-.46-1.158-.889l-.93-.706a.411.411 0 00-.25-.084H4.96c-2.104-.006-3.16-.003-3.562-.001zm2.946 6.595V11.2c0 .11.09.2.2.2h.831a.2.2 0 00.2-.2V7.055a.2.2 0 00-.2-.2h-.831a.2.2 0 00-.2.2v2.073z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function HauntIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          clipRule="evenodd"
          d="M1.848 3.858a4.26 4.26 0 018.423 0l.98 6.427c.135.89-.902 1.473-1.592.895l-.394-.33a.562.562 0 00-.859.17l-.07.136a1.04 1.04 0 01-1.825.034.52.52 0 00-.903 0 1.04 1.04 0 01-1.824-.034l-.07-.136a.562.562 0 00-.86-.17l-.394.33c-.69.578-1.726-.006-1.591-.895l.98-6.427zm3.75.462c0 .662-.474 1.2-1.059 1.2S3.48 4.983 3.48 4.32c0-.663.474-1.2 1.059-1.2s1.059.537 1.059 1.2zm1.983 1.2c.585 0 1.06-.537 1.06-1.2 0-.663-.475-1.2-1.06-1.2-.584 0-1.058.537-1.058 1.2 0 .662.474 1.2 1.058 1.2z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M0 0h12v12H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function HauntsCategoryIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn(
        "h-4.5 w-[19px] text-slate-gray transition-colors",
        className
      )}
      fill="none"
      viewBox="0 0 19 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3.272 5.787a6.39 6.39 0 0112.634 0l1.47 9.641c.203 1.334-1.354 2.209-2.388 1.342l-.59-.495a.843.843 0 00-1.289.255l-.106.204c-.572 1.092-2.125 1.121-2.737.051a.78.78 0 00-1.354 0c-.612 1.07-2.165 1.041-2.736-.051l-.106-.204a.843.843 0 00-1.288-.255l-.592.495c-1.034.867-2.59-.008-2.387-1.342l1.47-9.64zm5.624.693c0 .994-.71 1.8-1.588 1.8-.877 0-1.588-.806-1.588-1.8s.711-1.8 1.588-1.8c.877 0 1.588.806 1.588 1.8zm2.976 1.8c.877 0 1.588-.806 1.588-1.8s-.71-1.8-1.588-1.8c-.877 0-1.588.806-1.588 1.8s.71 1.8 1.588 1.8z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function IrlIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 8 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M7.575 1.05L3.213.075a.46.46 0 00-.36.075.398.398 0 00-.156.325v.562H.517a.423.423 0 00-.426.413v9.112c0 .225.193.413.426.413h2.167v.562a.46.46 0 00.155.325.403.403 0 00.258.088c.026 0 .065 0 .09-.013l4.362-.975a.405.405 0 00.322-.4V1.45a.354.354 0 00-.296-.4zm-4.89 9.1H.941v-8.3h1.742v8.3zM4.18 6.437A.45.45 0 013.73 6a.45.45 0 01.451-.438c.245 0 .452.2.452.438a.45.45 0 01-.452.437z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M0 0h8v12H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MortyIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 11 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="currentColor">
        <path d="M10.012.5H.153a.14.14 0 00-.152.128.142.142 0 00.124.156l7.65 1.643a.282.282 0 01.221.283v13.588a.282.282 0 01-.221.284l-7.65 1.634a.142.142 0 00-.124.156.14.14 0 00.152.127h9.86a.28.28 0 00.276-.283V.784a.28.28 0 00-.277-.283z" />
        <ellipse cx="6.355" cy="10.1" rx="0.303" ry="0.6" />
      </g>
    </svg>
  );
}

export function OtherIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          clipRule="evenodd"
          d="M13.398.056c-.122.053-.216.222-1.013 1.814-.54 1.08-.918 1.788-.98 1.837-.084.066-.455.131-1.96.345-1.022.145-1.909.273-1.972.285a.407.407 0 00-.325.396c0 .195-.122.063 1.643 1.77 1.132 1.094 1.288 1.26 1.288 1.371 0 .07-.141.941-.314 1.936-.173.996-.314 1.87-.314 1.945 0 .185.195.38.379.38.093 0 .676-.282 1.91-.924 1.363-.71 1.801-.92 1.878-.9.055.014.877.43 1.828.924 1.168.608 1.772.9 1.86.9a.391.391 0 00.371-.305c.014-.08-.11-.899-.308-2.039-.277-1.592-.324-1.923-.284-2.016.027-.062.397-.446.823-.855 1.45-1.392 2.054-2.004 2.08-2.105a.419.419 0 00-.012-.207c-.084-.236-.133-.248-2.155-.537-1.046-.149-1.955-.292-2.02-.317-.1-.04-.24-.292-1.017-1.844-.84-1.678-.91-1.8-1.044-1.857-.171-.071-.173-.071-.343.003zM3.973.65l-.294.536-.526.287c-.29.158-.517.302-.505.321.012.019.205.133.429.253s.458.254.52.297c.063.044.232.303.393.601l.282.524.07-.116c.038-.063.168-.299.288-.522.121-.224.27-.443.333-.486a8.68 8.68 0 01.541-.305c.236-.124.424-.24.418-.259-.005-.018-.244-.161-.53-.318l-.518-.284-.28-.51a11.275 11.275 0 00-.301-.53c-.014-.013-.157.217-.319.513zm3.134 6.086a15.598 15.598 0 00-4.493 4.44C1.084 13.48.242 16.043.028 19.035c-.056.791-.038.907.144.953.196.05.257-.034.462-.634.534-1.567 1.307-2.997 2.273-4.204a16.527 16.527 0 011.75-1.786c1.069-.9 2.508-1.707 3.789-2.128.196-.064.359-.119.363-.122.024-.016.44-2.544.422-2.562-.034-.034-1.102.57-1.727.978a22.276 22.276 0 00-2.01 1.494c-.512.437-1.54 1.46-1.98 1.97-.447.52-.498.563-.67.564-.261.002-.42-.276-.295-.515.086-.163.877-1.041 1.436-1.593a20.122 20.122 0 014.812-3.505c.152-.078.277-.153.277-.166 0-.026-1.407-1.38-1.434-1.38-.009 0-.249.153-.533.338zm7.084 7.46c-.045.075-.169.298-.275.496-.107.198-.227.389-.268.424-.04.035-.29.182-.555.326-.264.145-.485.266-.49.27a9.05 9.05 0 00.506.286c.283.155.544.314.58.354.034.04.16.253.276.472.341.637.29.63.591.08a6.11 6.11 0 01.328-.553c.037-.04.275-.188.53-.328s.48-.269.498-.287c.02-.018-.19-.157-.464-.31-.274-.151-.528-.309-.564-.35a5.982 5.982 0 01-.324-.545 6.016 6.016 0 00-.273-.47.614.614 0 00-.096.135z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M0 0h20v20H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PopUpIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.997 14.035V7.209c0-.019-.003-.037-.005-.055v-.01a.334.334 0 00-.037-.098l-.007-.014a.31.31 0 00-.068-.078l-.014-.011a.287.287 0 00-.093-.053l-.004-.002C18.703 6.865 12.29 4.53 10.83.233A.348.348 0 0010.5 0a.348.348 0 00-.331.233c-1.46 4.297-7.873 6.63-7.938 6.655 0 0-.003 0-.005.002a.407.407 0 00-.093.053l-.014.011a.363.363 0 00-.075.092.36.36 0 00-.037.098v.01c-.002.018-.005.036-.005.055v2.268l.022 4.22-.022 4.64a.345.345 0 00.345.386h.936c.168 0 .31-.117.343-.277l.915-4.533c.184-.345.621-2.916 4.17-4.072h3.58c3.537 1.152 3.981 4.002 4.168 4.35l.915 4.532a.35.35 0 00.342.277h.936c.1 0 .196-.041.261-.117a.34.34 0 00.084-.27v-4.578zm-1 4.278l-.784-3.891h1.085v3.891h-.3zm-15.3-.277v-3.891h1.082l-.785 3.891h-.298zm5.951-8.88H2.696V7.555h15.602v1.603h-9.65z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PortableIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 21 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.023 6.38h1.271v9.686H5.023V6.38zm8.791 0h1.271v9.686h-1.271V6.38zM4.182 16.866c-.724 0-1.274-.184-1.647-.553-.374-.365-.56-.91-.56-1.634V7.986c0-.729.186-1.276.56-1.64.373-.365.923-.547 1.647-.547h11.751c.73 0 1.278.182 1.648.547.373.364.56.911.56 1.64v6.693c0 .724-.187 1.269-.56 1.633-.37.37-.919.554-1.648.554H4.183zm.055-1.292h11.641c.297 0 .522-.08.677-.239.16-.155.24-.387.24-.697v-6.61c0-.315-.08-.55-.24-.705-.155-.155-.38-.232-.677-.232H4.237c-.296 0-.524.077-.684.232-.155.155-.232.39-.232.704v6.61c0 .31.077.543.232.698.16.16.388.24.684.24zm2.235-9.221V5.17c0-.643.178-1.121.533-1.436.356-.314.839-.471 1.45-.471h3.192c.647 0 1.14.157 1.476.471.342.315.513.793.513 1.436v1.176h-1.244v-1.17c0-.245-.068-.434-.205-.567-.132-.132-.324-.198-.574-.198h-3.11c-.251 0-.445.066-.582.198-.136.133-.205.322-.205.568v1.176H6.472z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ScareZoneIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M7.43 1.501a.2.2 0 00-.202.2v2.094c0 .11.09.2.2.2h1.678a.2.2 0 00.2-.2V1.71a.2.2 0 00-.199-.2L7.429 1.5zM2.196 4.722A.198.198 0 002 4.921v6.025c0 .11.089.2.2.2h11.683a.411.411 0 00.246-.082l1.65-1.235c.969-.724 1.833-1.395 1.92-1.49a.558.558 0 00-.035-.816c-.107-.1-.975-.767-1.93-1.482L14.11 4.806a.41.41 0 00-.248-.084H8.266c-3.77-.01-5.522-.004-6.069-.001zm5.042 10.99V19.3c0 .11.09.2.2.2h1.653a.2.2 0 00.2-.2v-7.175a.2.2 0 00-.2-.2H7.44a.2.2 0 00-.2.2v3.587z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function TabletopIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.141 1.102A.5.5 0 012.601.8H9.4a.5.5 0 01.459.302l1.64 3.8a.5.5 0 01-.46.698H.962a.5.5 0 01-.46-.698l1.64-3.8zM2 6h1.2l.18 4.68a.5.5 0 01-.5.52h-.199a.5.5 0 01-.5-.48L2 6zm6.8 0H10l-.181 4.72a.5.5 0 01-.5.48h-.2a.5.5 0 01-.499-.52L8.8 6zM7 6h1.2l-.076 1.525a.5.5 0 01-.5.475h-.198a.5.5 0 01-.5-.525L7 6zM3.8 6H5l.074 1.475a.5.5 0 01-.5.525h-.198a.5.5 0 01-.5-.475L3.8 6z"
        fill="currentColor"
      />
    </svg>
  );
}

export function VirtualIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.273 9.346l-1.128-1.505V2.297A.297.297 0 009.848 2H2.152a.297.297 0 00-.297.297v5.544L.726 9.346a.296.296 0 00.238.475h10.072a.297.297 0 00.237-.475zm-6.745-.119l.222-.495h2.5l.222.495H4.528zM9.55 7.643h-7.1V2.594h7.1v5.049z"
        fill="currentColor"
      />
    </svg>
  );
}

export function YardDisplayIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-pale-lavender transition-colors", className)}
      fill="none"
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          clipRule="evenodd"
          d="M6.692 2.816l.453-.08c.229-.04 1.448.012 1.734.075 1.037.23 1.83.667 2.603 1.438.652.65 1.144 1.421 1.38 2.165.029.093.048.152.047.212 0 .106-.064.212-.242.507-.329.547-.616 1.09-.59 1.116.01.01.37.125.801.255.431.131.797.251.812.267.033.035 2.047 7.389 2.029 7.407-.007.007-.104-.048-.215-.123-.347-.234-.603-.311-1.093-.33-.36-.014-.49-.002-.743.067-.338.092-.511.17-.638.286-.035.032-.055.05-.075.05-.03 0-.058-.042-.129-.143-.292-.419-.786-.79-1.303-.979-1.305-.476-2.567-.024-3.016 1.08-.05.126-.104.209-.12.184-.055-.09-.418-.239-.692-.284-.55-.09-1.136.076-1.444.41-.084.091-.122.133-.15.127-.025-.005-.043-.042-.076-.11-.09-.191-.37-.397-.664-.488-.07-.022-.116-.026-.153-.046-.099-.055-.134-.225-.408-1.168-.1-.347-.5-1.694-.888-2.994-.387-1.3-.73-2.524-.762-2.72-.259-1.573.079-3.386.838-4.503.618-.91 1.522-1.471 2.704-1.678zM1.842 4.74c.769-.768 1.708-1.328 2.906-1.73.289-.097.552-.177.584-.177.033 0-.078.075-.245.167-1.31.718-2.128 1.876-2.482 3.514-.073.338-.086.527-.088 1.283 0 .383-.002.616.021.847.037.369.135.731.39 1.684.273 1.016 1.47 4.963 1.641 5.408.013.035-.083.054-.348.07-.623.038-1.145.306-1.495.767l-.184.242-.471-1.386C1.089 12.544.343 10.205.22 9.629.127 9.194.13 8.263.227 7.757c.225-1.182.738-2.14 1.614-3.018zM9.11 16.033c.267-.263.533-.412.919-.513.344-.09.946-.103 1.233-.026.54.144.948.49 1.203 1.016.086.178.157.354.157.39 0 .128.054.11.284-.099.857-.775 2.063-.755 3.074.052.593.474 1.549 1.018 2.962 1.685.48.225.942.444 1.028.486.157.075.056.076-9.906.078L0 19.105l.257-.266c.141-.147.294-.339.339-.428.197-.385.735-.725 1.15-.725.268 0 .383.053.616.281l.2.198.023-.244c.082-.904 1.097-1.628 2.196-1.565.293.016.38.039.594.153.272.144.745.576.745.68 0 .11.056.07.136-.096.089-.186.303-.391.542-.518.14-.073.232-.09.524-.09.445 0 .643.086.995.437.245.243.247.244.27.14.115-.514.23-.74.523-1.029zM5.794 7.04a2.72 2.72 0 011.064-.73c.18-.069.846-.25 1.036-.282.473-.078.907-.05 1.314.086.213.071.582.28.776.44a3.4 3.4 0 01.51.548c.194.272.364.658.432.976.048.224.048.257-.002.54-.05.275-.047.366.012.544.053.163.1.224.326.418.201.174.247.24.284.412a.514.514 0 01-.001.274.671.671 0 01-.097.253c-.109.174-.152.204-.427.291-.13.041-.254.089-.276.106-.153.117-.22.365-.2.747.013.273-.023.363-.21.53-.258.23-.499.366-.887.5-.467.16-.925.233-1.281.204-.202-.017-.423-.068-.506-.117a.562.562 0 01-.19-.216 2.122 2.122 0 00-.246-.393c-.092-.107-.227-.195-.321-.209-.045-.006-.134.007-.303.045-.283.064-.334.061-.512-.031a.718.718 0 01-.356-.409c-.055-.167-.049-.247.037-.499.097-.282.107-.358.071-.525-.04-.184-.084-.264-.265-.477-.185-.218-.202-.247-.274-.464a2.856 2.856 0 01-.12-1.061c.02-.22.09-.525.164-.73.088-.24.3-.605.448-.771zm1.9 2.449a1.363 1.363 0 00-.502-.032 3.208 3.208 0 00-.577.125c-.313.152-.424.431-.338.848.068.33.279.569.546.62.168.033.313.018.55-.057.331-.105.486-.212.606-.42.158-.275.158-.707 0-.897a.543.543 0 00-.284-.187zm2.817-.156c-.1-.368-.313-.59-.585-.609a.872.872 0 00-.288.037 2.477 2.477 0 00-.228.064c-.41.177-.574.29-.69.472a.528.528 0 00-.021.498c.167.37.479.588.83.58a2.05 2.05 0 00.625-.152c.356-.182.471-.47.357-.89zm-1.826 1.43c-.036.032-.047.035-.088.026a.236.236 0 00-.058-.008c-.052.014-.155.344-.21.675-.031.19-.031.204.002.328.042.156.098.22.194.225.099.006.24-.083.33-.206.023-.03.034-.045.049-.05.014-.003.031.004.066.02.14.06.307.065.39.01.08-.053.095-.136.053-.292-.034-.124-.04-.136-.165-.285-.16-.192-.41-.436-.474-.461-.044-.018-.05-.016-.089.018z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M0 .5h20v20H0z" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
